window.addEventListener("load", () => {
  // https://www.w3schools.com/js/js_cookies.asp
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // Retrieve the `hubspotutk` cookie and add it as a hidden fields to Hubspot forms
  // https://developers.hubspot.com/docs/methods/forms/submit_form
  const hubspotCookie = getCookie("hubspotutk");

  const hubspotForms = document.querySelectorAll("[data-hubspot-form]");
  if (hubspotForms && hubspotCookie) {
    hubspotForms.forEach(form => {
      var cookieField = form.querySelector("[data-hubspot-cookie-field]");
      cookieField.value = hubspotCookie;

      // Safety net to make sure we have a `utk` value
      const submitButton = form.querySelector('button[type="submit"]');
      submitButton.addEventListener("click", () => {
        if(cookieField.value == "") {
          cookieField.value = hubspotCookie;
        }
      });
    });
  }

  // Use `hutbspotutk` and UTMs parameters in tito registration metadata.
  const hubspotTitoPrefills = document.querySelectorAll("[data-hubspot-tito-prefill]");
  for(let prefill of hubspotTitoPrefills) {
    let attrValue = prefill.getAttribute("prefill");
    let json = JSON.parse(attrValue);
    if(!json.metadata) {
      json.metadata = {};
    }

    json.metadata.hubspotutk = hubspotCookie;

    // Grab the UTMs parameters
    if("URLSearchParams" in window) {
      const params = Object.fromEntries(new URLSearchParams(location.search));
      for(let param in params) {
        json.metadata[param] = params[param];
      }
    }

    prefill.setAttribute("prefill", JSON.stringify(json));
  }
});
